module.exports = __webpack_public_path__ + "media/images/market_trends-de533043c67cb77f7d364f71d3dc5dd7.svg";